'use client'

import { useEffect, useRef } from 'react'
import { usePathname } from 'next/navigation'

import { useViewer } from '../hooks/use-viewer'

export default function ViewerSync() {
  const pathname = usePathname()
  const { refresh } = useViewer()
  const lastPathname = useRef(pathname)

  useEffect(() => {
    if (lastPathname.current === pathname) return
    lastPathname.current = pathname
    void refresh()
  }, [pathname, refresh])

  return null
}
